import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import {
  IThunkArchiveSecondaryDiagnosis,
  IClientDetailsStore,
  IClientDetailsActions,
} from '../types';

const onArchiveSecondaryDiagnosis: IThunkArchiveSecondaryDiagnosis = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.archiveClientSecondaryDiagnosis(payload);

    const diagnoses = localState.diagnoses.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: true },
    );

    setClientDetails({ diagnoses });
  },
);

export default onArchiveSecondaryDiagnosis;
